import { useIntl } from 'react-intl';
import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';

const COLORS = ['#775175', '#D99455']; // Colors for Sale and Rent

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}: {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
  value: number;
  index: number;
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 2.2;
  const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
  const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);

  return (
    <text
      x={x}
      y={y}
      fill={COLORS[index % COLORS.length]}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontSize={14}
      fontWeight={500}
      fontFamily="Roboto"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

// Componente Tooltip personalizado para redondear valores
const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <p style={{ margin: 0, fontWeight: 'bold' }}>
          {payload[0].name}: {Math.round(payload[0].value)} %
        </p>
      </div>
    );
  }
  return null;
};

const OfferByPurposeChart = ({
  data,
}: {
  data: { sale: number | null; rent: number | null };
}) => {
  // Prepare the data for the PieChart
  const intl = useIntl();
  const chartData = [
    { name: intl.formatMessage({ id: 'offerDemand.sale' }), value: data.sale },
    { name: intl.formatMessage({ id: 'offerDemand.rent' }), value: data.rent },
  ];
  return (
    <PieChart width={250} height={100}>
      <Legend
        verticalAlign="middle"
        align="left"
        layout="vertical"
        wrapperStyle={{ fontSize: '12px' }}
      />
      <Pie
        data={chartData}
        cx="50%"
        cy="50%"
        isAnimationActive={false}
        innerRadius={25}
        outerRadius={34}
        fill="#8884d8"
        paddingAngle={1}
        dataKey="value"
        label={renderCustomizedLabel}
        labelLine={false}
      >
        {chartData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Tooltip content={<CustomTooltip />} />
    </PieChart>
  );
};

export default OfferByPurposeChart;
